import { render, staticRenderFns } from "./InvoicesAdd.vue?vue&type=template&id=3165310a&"
import script from "./InvoicesAdd.vue?vue&type=script&lang=js&"
export * from "./InvoicesAdd.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports